import { Engagement } from '@ms/odsp-utilities/lib/logging/events/Engagement.event';
import { IEngagementExtraData, ShareType, ClientId, Mode } from '../interfaces/SharingInterfaces';
import * as PeoplePickerHelper from "./PeoplePickerHelper";
import { IPerson } from '@ms/odsp-datasources/lib/PeoplePicker';

const ENGAGEMENT_PREFIX = 'ShareV3';

export function opened(extraData: IEngagementExtraData) {
    this._log('Opened', extraData);
}

export function linkSettingsOpened(extraData: IEngagementExtraData) {
    this._log('LinkSettings.Opened', extraData);
}

export function linkSettingsApplyClicked(extraData: IEngagementExtraData) {
    this._log('LinkSettings.ApplyClicked', extraData);
}

export function linkSettingsCancelClicked(extraData: IEngagementExtraData) {
    this._log('LinkSettings.CancelClicked', extraData);
}

export function linkSettingsLearnMoreClicked(extraData: IEngagementExtraData) {
    this._log('LinkSettings.LearnMoreClicked', extraData);
}

export function manageAccessOpened(extraData: IEngagementExtraData) {
    this._log('ManageAccess.Opened', extraData);
}

export function shareCompleted(extraData: IEngagementExtraData) {
    this._log('Completed', extraData);
}

export function sendACopyClicked(extraData: IEngagementExtraData) {
    this._log('SendACopy.Clicked', extraData);
}

export function sendACopyOfficeClicked(extraData: IEngagementExtraData) {
    this._log('SendACopy.OfficeClicked', extraData);
}

export function sendACopyPdfClicked(extraData: IEngagementExtraData) {
    this._log('SendACopy.PdfClicked', extraData);
}

export function whoElseHasAccessClicked(extraData: IEngagementExtraData) {
    this._log('WhoElseHasAccess.Clicked', extraData);
}

export function shareTargets(extraData: IEngagementExtraData) {
    this._log('ShareTargets', extraData);
}

export function trackClickThru(extraData: IEngagementExtraData) {
    this._log('ClickThruTracker', extraData);
}

export function externalSharingCslError(extraData: IEngagementExtraData) {
    this._log('externalSharingCslError', extraData);
}

export function copyLinkInterruptOpened(extraData: IEngagementExtraData) {
    this._log('copyLinkInterruptOpened', extraData);
}

export function copyLinkInterruptEditLinkChosen(extraData: IEngagementExtraData) {
    this._log('copyLinkInterruptEditLinkChosen', extraData);
}

export function copyLinkInterruptExistingLinkChosen(extraData: IEngagementExtraData) {
    this._log('copyLinkInterruptExistingLinkChosen', extraData);
}

export function copyLinkInterruptCancelled(extraData: IEngagementExtraData) {
    this._log('copyLinkInterruptCancelled', extraData);
}
// Log how many linkedin suggestions are selected in people picker
export function peoplePickerLinkedinSuggestionSelected(extraData: IEngagementExtraData, suggestions: IPerson[]) {
    this._log('PeoplePicker.SuggestionSelected', { ...extraData, linkedinSuggestionsSelectedCount: PeoplePickerHelper.getLinkedInPeopleCount(suggestions) });
}

// Log how many linkedin suggestions are returned in people picker
export function peoplePickerLinkedinSuggestions(extraData: IEngagementExtraData, suggestions: IPerson[]) {
    this._log('PeoplePicker.Suggestions', { ...extraData, linkedinSuggestionsCount: PeoplePickerHelper.getLinkedInPeopleCount(suggestions) });
}

export function _log(eventName: string, extraData: IEngagementExtraData) {
    // Get string values of enums so charts are nicer.
    const friendlyExtraData = {
        ...extraData,
        clientId: ClientId[extraData.clientId],
        scenarioId: extraData.scenarioId,
        mode: Mode[extraData.mode],
        shareType: ShareType[extraData.shareType],
        audience: extraData.audience,
        shareTargets: this._getFriendlyShareTargets(extraData.shareTargets)
    };

    const engagementPayload = {
        name: `${ENGAGEMENT_PREFIX}.${eventName}`,
        webTemplateId: extraData.webTemplateId ? extraData.webTemplateId.toString() : undefined,
        extraData: friendlyExtraData
    };

    Engagement.logData(engagementPayload);
}

export function _getFriendlyShareTargets(originalShareTargets: ShareType[]) {
    const friendlyShareTargets = [];

    if (originalShareTargets) {
        for (const shareTarget of originalShareTargets) {
            friendlyShareTargets.push(ShareType[shareTarget]);
        }
    }

    return friendlyShareTargets;
}